import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import { useInviteUser } from '../../data/useAccountUsers';

interface InviteUserDialogProps {
  open: boolean;
  onClose: () => void;
  accountId: string | undefined;
}

const InviteUserDialog: React.FC<InviteUserDialogProps> = ({
  open,
  onClose,
  accountId,
}) => {
  const [email, setEmail] = React.useState('');
  const [role, setRole] = React.useState('viewer');
  const [error, setError] = React.useState<string | null>(null);
  const inviteUser = useInviteUser(accountId);

  const handleSubmit = () => {
    setError(null);
    inviteUser.mutate(
      { email, role },
      {
        onSuccess: () => {
          setEmail('');
          setRole('viewer');
          onClose();
        },
        onError: (err: any) => {
          const detail =
            err?.response?.data?.detail || 'Failed to send invitation';
          setError(detail);
        },
      },
    );
  };

  const handleClose = () => {
    setEmail('');
    setRole('viewer');
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Invite User</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          autoFocus
          label="Email"
          type="email"
          fullWidth
          size="small"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mt: 1, mb: 2 }}
        />
        <TextField
          select
          label="Role"
          fullWidth
          size="small"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <MenuItem value="viewer">Viewer</MenuItem>
          <MenuItem value="creator">Creator</MenuItem>
          <MenuItem value="account-admin">Account Admin</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!email || inviteUser.isPending}
        >
          {inviteUser.isPending ? 'Sending...' : 'Send Invite'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteUserDialog;
